import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrDatePicker from '../components/FrDatePicker'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, getData } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const pageName='relatos_abertos'

const swal = withReactContent(Swal)

function RelatosAbertos(props) {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authIntcc'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboTpa, setComboTpa] = useState([ { VALUE: '', DISPLAY: 'Todos' }, { VALUE: '1', DISPLAY: 'Triagem' }, { VALUE: '2', DISPLAY: 'Atendimento' }, { VALUE: '3', DISPLAY: 'Consulta Psiquiátrica' }])

  const columns = [
    { id: 'NUMERO_PRONTUARIO', numeric: false, label: 'Nº Prontuário', align: 'left', Width: 80 },
    { id: 'FORMATDATA_ATEND', numeric: false, label: 'Data Atendimento', align: 'left', minWidth: 150 },
    { id: 'NOMETPA', numeric: false, label: 'Tipo Atendimento', align: 'left', minWidth: 150 },
    { id: 'NOMETRI', numeric: false, label: 'Profissional', align: 'left', minWidth: 330 },
    { id: 'NOMEPAC', numeric: false, label: 'Paciente 1', align: 'left', minWidth: 300 },
    { id: 'NOMEPAC2', numeric: false, label: 'Paciente 2', align: 'left', minWidth: 300 },
    { id: 'NOMETPP', numeric: false, label: 'Tipo Prontuário', align: 'left', minWidth: 250 },
    { id: 'PK_MOV', numeric: false, label: 'Nº Relato', align: 'left', minWidth: 70 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setenableAdd(await api.getAcessos(pageName, 'Inclusao'))
      setenableEdit(await api.getAcessos(pageName, 'Alteracao'))
      setenableDel(await api.getAcessos(pageName, 'Exclusao'))



      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      console.log(query)
      query.usu_logado = auth.user
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        console.log(pageName)
        getData(event, setData, setFiltered, pageName)
      }
    }

    fetchData()
  }, [])

  function getExtraData(e) {
   return
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/intcc/relatos_abertos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

 

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(auxValues)
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Relatos em Aberto</h3>
          <UserOptions  />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              
              <FrTextInput
                value={filter.numero_prontuario || ''}
                style={{ width: 330 }}
                name="numero_prontuario"
                id="numero_prontuario"
                color="#389492"
                label="Nº Prontuário"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              <FrDatePicker
                value={(filter.dataIniWeb || '').split('T')[0]}
                name="dataIniWeb"
                id="dataIniWeb"
                color="#528b46"
                label="Data Inicial"
                variant="outlined"
                onChange={handleChange}
                size="small"
                style={{ width: 180 }}
    
              />
              <FrDatePicker
                value={(filter.dataFimWeb || '').split('T')[0]}
                name="dataFimWeb"
                id="dataFimWeb"
                color="#528b46"
                label="Data Final"
                variant="outlined"
                onChange={handleChange}
                size="small"
                style={{ width: 180 }}
    
              />
              <FrSelect
                value={filter.fk_tpa || ''}
                style={{ width: 340 }}
                name="fk_tpa"
                id="fk_tpa"
                label='Tipo Atendimento'
                data={comboTpa}
                onChange={handleChange}
              />
<FrTextInput
                value={auth.user || ''}
                style={{ width: 330 }}
                name="usu_logado"
                id="usu_logado"
                color="#389492"
                label="Nº Prontuário"
                variant="outlined"
                size="small"
                hidden
                onChange={handleChange}
              />
            </div>
            <div>
              <button onClick={(e) => getData(e, setData, setFiltered, pageName)}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/intcc/relatos_abertos/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>
                </Link>}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable 
            regName={'prontuario_eletronico'} 
            columns={columns} 
            searched={filtered} 
            columnToOrder={2} 
            ascDescOrder={'desc'} 
            codeName="PK_MOV" 
            page={'prontuario_eletronico'} 
            data={data} 
            enableEdit={enableEdit} 
            uploadArquivos={'N'} 
            downloadArquivos={'N'} 
            enableDel={false} 
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RelatosAbertos;
